import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../../features/auth/auth.service';
import { LoggerService } from '../services/logger.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(private authService: AuthService, private router: Router, private logger: LoggerService) { }

    canActivate(): boolean {
        const token = this.authService.getToken();
        this.logger.debug('AuthGuard: token present =', !!token);
        if (token) {
            return true;
        } else {
            this.router.navigate(['/auth/login']); // Redirect to login if not authenticated
            return false;
        }
    }
}
